export enum EventType {
  CREATED = 'created',
  ACCEPTED = 'accepted',
  SCHEDULED = 'scheduled',
  RESCHEDULED = 'rescheduled',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  ALREADYBOOKED = 'alreadyBooked',
  EMAILRESPONDER = 'emailResponder',
  AUTOCANCEL = 'autoCancel',
  PULLED = 'pulled',
  PRE_BOOK = 'pre_book',
}

export enum EventTypeCondition {
  IMMEDIATE = 'immediate',
  BEFORE = 'before',
  AFTER = 'after',
  NO_RESPONSE = 'no_response',
}

export enum TemplateScope {
  GENERAL = 'general',
  CONVERSATION = 'conversation'
}

export enum ReplyType {
  EMAIL = 'email',
  SMS = 'textbot',
  CALL = 'callbot'
}

export const ReplyTypeLabels: Record<ReplyType, string> = {
  [ReplyType.EMAIL]: 'No Action (Standard Email)',
  [ReplyType.SMS]: 'Trigger Textbot (SMS)',
  [ReplyType.CALL]: 'Trigger Callbot (Coming Soon)',
};